<div class="mat-dialog-title">
  <p>Dados da empresa no MDM</p>
</div>

<div mat-dialog-content class="mat-dialog-content">
  <div class="warning-msg" *ngIf="data.isStaging()">
    <span><strong>Atenção!</strong> Empresa em processo de aprovação no MDM de empresas.</span>
    <mat-icon (click)="refreshCompanyMasterData()">loop</mat-icon>
  </div>

  <form class="general-data-form" [formGroup]="companyMasterDataForm" fxFlex  fxLayout="column">
    <div fxFlex>
      <mat-form-field fxFlex="25">
        <mat-label>CNPJ</mat-label>
        <input
          matInput
          formControlName="fiscalNumber"
          type="text"
          placeholder="CNPJ"
          [textMask]="{
            mask: fiscalNumberMask,
            guide: false,
            keepCharPositions: true
          }"
          readonly />
      </mat-form-field>

      <mat-form-field fxFlex>
        <mat-label>Razão Social</mat-label>
        <input matInput formControlName="corporateName" type="text" placeholder="Razão Social" style="text-overflow: ellipsis" readonly />
      </mat-form-field>

      <mat-form-field fxFlex>
        <mat-label>Nome Fantasia</mat-label>
        <input matInput formControlName="tradingName" type="text" placeholder="Nome Fantasia" style="text-overflow: ellipsis" readonly />
      </mat-form-field>
    </div>
    <div fxFlex>
      <mat-form-field fxFlex>
        <mat-label>Tipo</mat-label>
        <input matInput formControlName="type" type="text" placeholder="Tipo" readonly />
      </mat-form-field>

      <mat-form-field fxFlex>
        <mat-label>Bandeira</mat-label>
        <input matInput formControlName="drugFront" type="text" placeholder="Bandeira" readonly />
      </mat-form-field>

      <mat-form-field fxFlex>
        <mat-label>Situação</mat-label>
        <input matInput formControlName="situation" type="text" placeholder="Situação" readonly />
      </mat-form-field>
    </div>
    <div fxFlex>
      <mat-form-field fxFlex>
        <mat-label>Contrato</mat-label>
        <input matInput formControlName="contract" type="text" placeholder="Contrato" readonly />
      </mat-form-field>

      <mat-form-field fxFlex>
        <mat-label>Ramo</mat-label>
        <input matInput formControlName="branch" type="text" placeholder="Ramo" readonly />
      </mat-form-field>

      <mat-form-field fxFlex>
        <mat-label>Subramo</mat-label>
        <input matInput formControlName="subBranch" type="text" placeholder="Subramo" readonly />
      </mat-form-field>

      <mat-form-field fxFlex>
        <mat-label>Cluster</mat-label>
        <input matInput formControlName="cluster" type="text" placeholder="Cluster" readonly />
      </mat-form-field>
    </div>
  </form>

  <form class="address-form" [formGroup]="companyMasterDataForm" fxFlex fxLayout="column">
    <div fxFlex>
      <mat-form-field fxFlex>
        <mat-label>Endereço</mat-label>
        <input matInput formControlName="street" type="text" placeholder="Endereço" readonly />
      </mat-form-field>

      <mat-form-field fxFlex="15">
        <mat-label>Número</mat-label>
        <input matInput formControlName="number" type="text" placeholder="Número" readonly />
      </mat-form-field>

      <mat-form-field fxFlex>
        <mat-label>Complemento</mat-label>
        <input matInput formControlName="complement" type="text" placeholder="Complemento" readonly />
      </mat-form-field>
    </div>
    <div fxFlex>
      <mat-form-field fxFlex>
        <mat-label>CEP</mat-label>
        <input
          matInput
          formControlName="zipCode"
          type="text"
          placeholder="CEP"
          [textMask]="{
            mask: zipCodeMask,
            guide: false,
            keepCharPositions: true
          }"
          readonly />
      </mat-form-field>

      <mat-form-field fxFlex>
        <mat-label>Município</mat-label>
        <input matInput formControlName="district" type="text" placeholder="Município" readonly />
      </mat-form-field>

      <mat-form-field fxFlex>
        <mat-label>Cidade</mat-label>
        <input matInput formControlName="city" type="text" placeholder="Cidade" readonly />
      </mat-form-field>

      <mat-form-field fxFlex>
        <mat-label>UF</mat-label>
        <input matInput formControlName="region" type="text" placeholder="UF" readonly />
      </mat-form-field>
    </div>
  </form>
</div>

<div mat-dialog-actions class="mat-dialog-actions">
  <div class="btn close-btn" (click)="close()">
    <span>Fechar</span>
  </div>

  <div *ngIf="!data.isStaging()" class="btn submit-btn" (click)="useCompanyMasterData()">
    <span>Usar dados</span>
  </div>
</div>
